import { List, ListItem, ListItemText } from "@mui/material"

export function FeatureFlagDescription() {
    return (
        <List disablePadding>
            <ListItem
                sx={{
                    p: 0,
                    pb: 1,
                }}
            >
                <ListItemText
                    primary={`\u2022 Enables clients to print individual schedules inside maintenance regimes.`}
                />
            </ListItem>
            <ListItem
                sx={{
                    p: 0,
                    pb: 1,
                }}
            >
                <ListItemText
                    primary={`\u2022 This is also available to users via a share link (if data export type is enabled).`}
                />
            </ListItem>
        </List>
    )
}
